import React, { useState, useEffect } from 'react';
import { Phone, Mail, Facebook, Instagram, Menu, X } from 'lucide-react';
import { businessInfo } from '../mockData';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };

  const navItems = [
    { label: 'Accueil', id: 'hero' },
    { label: 'Services', id: 'services' },
    { label: 'Tarifs', id: 'pricing' },
    { label: 'Zone d\'intervention', id: 'zone-intervention' },
    { label: 'Galerie', id: 'gallery' },
    { label: 'À propos', id: 'about' },
    { label: 'Avis', id: 'reviews' },
    { label: 'FAQ', id: 'faq' },
    { label: 'Conditions', id: 'terms' },
    { label: 'Contact', id: 'contact' }
  ];

  return (
    <>
      {/* Top bar */}
      <div className="bg-gradient-to-r from-[#8B9E8A] to-[#9CAF88] text-white py-2">
        <div className="container mx-auto px-4 flex justify-between items-center text-sm">
          <div className="flex items-center gap-4">
            <a href={`tel:${businessInfo.phone}`} className="flex items-center gap-2 hover:text-[#B8860B] transition-colors">
              <Phone size={14} className="text-[#B8860B]" />
              <span className="hidden sm:inline">{businessInfo.phone}</span>
            </a>
            <a href={`mailto:${businessInfo.email}`} className="flex items-center gap-2 hover:text-[#B8860B] transition-colors">
              <Mail size={14} className="text-[#B8860B]" />
              <span className="hidden md:inline">{businessInfo.email}</span>
            </a>
          </div>
          <div className="flex items-center gap-3">
            <a href={businessInfo.facebook} target="_blank" rel="noopener noreferrer" className="text-[#B8860B] hover:text-[#C5A572] transition-colors">
              <Facebook size={16} />
            </a>
            <a href={businessInfo.instagram} target="_blank" rel="noopener noreferrer" className="text-[#B8860B] hover:text-[#C5A572] transition-colors">
              <Instagram size={16} />
            </a>
          </div>
        </div>
      </div>

      {/* Main header */}
      <header className={`sticky top-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
      }`}>
        <div className="container mx-auto px-4 py-4">
          <div className="flex justify-between items-center">
            {/* Logo */}
            <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
              <img 
                src="https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/oowyuozl_IMG_2303.png" 
                alt="Gratia Animalis Logo" 
                className="h-12 w-auto"
              />
              <div>
                <h1 className="text-2xl font-bold text-[#8B9E8A]">{businessInfo.name}</h1>
                <p className="text-xs text-[#C5A572] hidden sm:block">{businessInfo.tagline}</p>
              </div>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-6">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-[#8B9E8A] hover:text-[#C5A572] transition-colors font-medium"
                >
                  {item.label}
                </button>
              ))}
              <button
                onClick={() => scrollToSection('contact')}
                className="bg-gradient-to-r from-[#C5A572] to-[#B8860B] text-white px-6 py-2 rounded-full font-semibold hover:shadow-lg transition-all duration-300 hover:scale-105"
              >
                Prendre RDV
              </button>
            </nav>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden text-[#8B9E8A] p-2"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
            <nav className="container mx-auto px-4 py-4 flex flex-col gap-3">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-[#8B9E8A] hover:text-[#C5A572] transition-colors font-medium text-left py-2"
                >
                  {item.label}
                </button>
              ))}
              <button
                onClick={() => scrollToSection('contact')}
                className="bg-gradient-to-r from-[#C5A572] to-[#B8860B] text-white px-6 py-3 rounded-full font-semibold hover:shadow-lg transition-all duration-300 text-center mt-2"
              >
                Prendre RDV
              </button>
            </nav>
          </div>
        )}
      </header>
    </>
  );
};

export default Header;
